import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, FormGroup, Input } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import { useTranslation } from "../hooks/useTranslation";
import "../styles/contact.css";

const socialLinks = [
  { url: "#", icon: "ri-facebook-fill", color: "#1877F2" },
  { url: "#", icon: "ri-instagram-line", color: "#E4405F" },
  { url: "#", icon: "ri-linkedin-fill", color: "#0A66C2" },
  { url: "#", icon: "ri-twitter-fill", color: "#1DA1F2" },
  { url: "#", icon: "ri-whatsapp-line", color: "#25D366" },
];

const Contact = () => {
  const t = useTranslation();

  return (
    <Helmet title={t("contact.contact")}>
      <CommonSection title={t("contact.contact")} />

      <section className="contact__section">
        <Container>
          
          <Row className="justify-content-center">
            <Col lg="8" className="text-center mb-5">
              <h2 className="section__title">{t("contact.sectionTitle")}</h2>
              <p className="section__subtitle">
                {t("contact.sectionSubtitle")}
              </p>
               <p className="section__description">
                        {t("contact.contactdescription")}
                      </p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col lg="6" md="6">
              <div className="contact__form-container">
                <Form className="contact__form">
                  <h4 className="form__title">{t("contact.formTitle")}</h4>

                  <FormGroup className="form__group">
                    <Input
                      placeholder={t("contact.namePlaceholder")}
                      type="text"
                      className="form__input"
                    />
                    {/* <i className="ri-user-line input-icon"></i> */}
                  </FormGroup>

                  <FormGroup className="form__group">
                    <Input
                      placeholder={t("contact.emailPlaceholder")}
                      type="email"
                      className="form__input"
                    />
                    {/* <i className="ri-mail-line input-icon"></i> */}
                  </FormGroup>

                  <FormGroup className="form__group">
                    <Input
                      placeholder={t("contact.phonePlaceholder")}
                      type="text"
                      className="form__input"
                    />
                    {/* <i className="ri-phone-line input-icon"></i> */}
                  </FormGroup>

                  <FormGroup className="form__group">
                    <textarea
                      rows="5"
                      placeholder={t("contact.messagePlaceholder")}
                      className="form__textarea"
                    ></textarea>
                    {/* <i className="ri-message-line textarea-icon"></i> */}
                  </FormGroup>

                  <button className="primary__btn" type="submit">
                    <i className="ri-send-plane-fill"></i>{" "}
                    {t("contact.sendButton")}
                  </button>
                </Form>
              </div>
            </Col>

            <Col lg="6" md="6">
              <div className="contact__info-container">
                <div className="contact__info-header">
                  <h4 className="info__title">{t("contact.infoTitle")}</h4>
                  <p className="info__subtitle">{t("contact.infoSubtitle")}</p>
                </div>

                <div className="contact__info-content">
                  <div className="info__item">
                    <div className="info__icon">
                      <i className="ri-map-pin-fill"></i>
                    </div>
                    <div className="info__text">
                      <h6>{t("contact.locationTitle")}</h6>
                      <p>{t("footerr.contact.address")}</p>
                    </div>
                  </div>

                  <div className="info__item">
                    <div className="info__icon">
                      <i className="ri-phone-fill"></i>
                    </div>
                    <div className="info__text">
                      <h6>{t("contact.phoneTitle")}</h6>
                      <p>{t("footerr.contact.phone")}</p>
                    </div>
                  </div>

                  <div className="info__item">
                    <div className="info__icon">
                      <i className="ri-mail-fill"></i>
                    </div>
                    <div className="info__text">
                      <h6>{t("contact.emailTitle")}</h6>
                      <p>Ksa@unitedlimited.net </p>
                    </div>
                  </div>

                  <div className="info__item">
                    <div className="info__icon">
                      <i className="ri-time-fill"></i>
                    </div>
                    <div className="info__text">
                      <h6>{t("contact.hoursTitle")}</h6>
                      <p>{t("contact.weekdaysHours")}</p>
                      {/* <p>{t("contact.weekendHours")}</p> */}
                    </div>
                  </div>
                </div>

                <div className="social__links-container">
                  <h6 className="social__title">{t("contact.followUs")}</h6>
                  <div className="social__links">
                    {socialLinks.map((item, index) => (
                      <a
                        href={item.url}
                        key={index}
                        className="social__link"
                        style={{ backgroundColor: item.color }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className={item.icon}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Contact;
